import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RiceBowlIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rice_bowl"}/>
}
